<h1>Portail de test chatbot Generate IT</h1>

@if (idToken) {
  <h2>User</h2>
  <p>{{ sub }}</p>
}

<p>
  <button (click)="login()">Login</button>
  @if (idToken) {
    <button (click)="refresh()">Refresh</button>
    <button (click)="logout()">Logout</button>
  }
</p>

<h2>Chatbot validation</h2>
<button (click)="showValidation()">Show chatbot icon</button>
<button (click)="openValidation()">Open in new tab</button>
<button (click)="hideChatBot()">Hide chatbot icon</button>

<h2>Chatbot staging</h2>
<button (click)="showStaging()">Show chatbot icon</button>
<button (click)="openStaging()">Open in new tab</button>
<button (click)="hideChatBot()">Hide chatbot icon</button>

<h2>Chatbot production</h2>
<button (click)="showProduction()">Show chatbot icon</button>
<button (click)="openProduction()">Open in new tab</button>
<button (click)="hideChatBot()">Hide chatbot icon</button>
